export default __webpack_public_path__ + "media/images/logos/portfolio_logo-9846791437c30634d7b823ac11d07954.svg";